<!-- CONTACT FORM
        ================================================== -->
<section class="bg-light-yellow pb-5 pt-5">
    <div class="container">
        <div class="row justify-content-center">

            <div class="col-lg-5">

                <div class="contact-form text-center">
                    <h2>Thank you</h2>
                    <p>Contest Participation Form submitted successfully</p>
                    <br>
                    <br><br><br><br><br>
                </div>

            </div>
        </div>



    </div>
</section>